/* FUNCTIONS – product page interactions
 * - Variant card selection
 * - Cart fetch + count update
 * Accordions use native <details> – no JS needed.
 */
(function () {
  // ---- Summer Offer in die Kartenpreise spiegeln --------------------------
  // Die Karten nennen den Paketpreis ohne den Bestellrabatt. Greift das
  // Angebot fuer die gewaehlte Menge, rechnen wir es hier hinein, damit Preis
  // pro Packung, Preis pro Nacht und Button dieselbe Zahl zeigen wie der
  // Warenkorb. data-variant-price bleibt unangetastet — die Sticky-Leiste
  // schlaegt den Rabatt selbst auf und wuerde ihn sonst doppelt abziehen.
  const MONEY = /\d[\d.,]*/;

  function toCents(text) {
    const m = String(text || '').match(MONEY);
    if (!m) return null;
    let s = m[0];
    if (s.indexOf('.') > -1 && s.indexOf(',') > -1) s = s.replace(/\./g, '');
    s = s.replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? Math.round(n * 100) : null;
  }

  // Ersetzt nur die Zahl und laesst Waehrungszeichen und Zusatz stehen,
  // egal ob "€ 37,47" oder "1,25 € / Nacht".
  function withAmount(text, cents) {
    return String(text).replace(MONEY, (cents / 100).toFixed(2).replace('.', ','));
  }

  function applySummerOffer(root) {
    const bar = document.querySelector('[data-offer-topbar]');
    if (!bar) return;
    const pct = parseFloat(bar.getAttribute('data-pct')) || 0;
    const min = parseInt(bar.getAttribute('data-min'), 10) || 0;
    if (pct <= 0 || min <= 0) return;

    root.querySelectorAll('[data-variant-wrap]').forEach((wrap) => {
      const qty = parseInt(wrap.dataset.variantQty, 10) || 0;
      const total = toCents(wrap.dataset.variantPrice);
      if (qty < min || total === null) return;

      // Shopify schneidet den Rabattbetrag auf volle Cent ab, nicht den
      // Endpreis — anders gerundet weicht die Karte um einen Cent ab.
      const offer = total - Math.floor((total * pct) / 100);
      wrap.dataset.variantOfferPrice = withAmount(wrap.dataset.variantPrice, offer);

      const priceEl = wrap.querySelector('.fn2-phero__price');
      if (priceEl) priceEl.textContent = withAmount(priceEl.textContent, Math.round(offer / qty));

      // Die Naechte stecken nur im Verhaeltnis Gesamtpreis zu Preis pro Nacht.
      const unitEl = wrap.querySelector('.fn2-phero__unit');
      const unit = unitEl ? toCents(unitEl.textContent) : null;
      if (unitEl && unit) {
        const nights = Math.round(total / unit);
        const perNight =
          nights >= 1 && nights <= 3650
            ? Math.round(offer / nights)
            : Math.round((unit * (100 - pct)) / 100);
        unitEl.textContent = withAmount(unitEl.textContent, perNight);
        wrap.dataset.variantPerUnit = unitEl.textContent;
      }

      // Ersparnis gegen den regulaeren Packungspreis, sonst steht dort der
      // Vorteil ohne das Angebot und wirkt kleiner als er ist.
      const compare = toCents(wrap.querySelector('.fn2-phero__compare')?.textContent);
      const savingEl = wrap.querySelector('.fn2-phero__saving');
      if (savingEl && compare) {
        savingEl.textContent = withAmount(savingEl.textContent, compare * qty - offer);
      }

      const pickEl = wrap.querySelector('.fn2-phero__pick-price');
      if (pickEl) pickEl.textContent = wrap.dataset.variantOfferPrice;
    });
  }

  function initVariantPicker(root) {
    const wraps = root.querySelectorAll('[data-variant-wrap]');
    const cards = root.querySelectorAll('[data-variant-card]');
    const hiddenInput = root.querySelector('input[name="id"]');
    const qtyInput = root.querySelector('input[name="quantity"]');
    const cta = root.querySelector('[data-add-to-cart]');
    const ctaPrice = root.querySelector('[data-cta-price]');

    applySummerOffer(root);

    function select(wrap) {
      const card = wrap.querySelector('[data-variant-card]');
      wraps.forEach((w) => {
        w.classList.remove('is-active');
        const c = w.querySelector('[data-variant-card]');
        if (c) c.setAttribute('aria-checked', 'false');
      });
      wrap.classList.add('is-active');
      if (card) card.setAttribute('aria-checked', 'true');
      // Die Karten teilen das fw-plan-Markup mit der Startseite: dort steuert
      // input:checked das CSS, deshalb muss die Auswahl auch am Radio landen.
      const radio = wrap.querySelector('input[type="radio"]');
      if (radio && !radio.checked) radio.checked = true;
      const id = wrap.dataset.variantId;
      const qty = wrap.dataset.variantQty || '1';
      const price = wrap.dataset.variantOfferPrice || wrap.dataset.variantPrice;
      if (hiddenInput) hiddenInput.value = id;
      if (qtyInput) qtyInput.value = qty;
      if (cta) {
        cta.dataset.variantId = id;
        cta.dataset.variantQty = qty;
      }
      if (ctaPrice && price) ctaPrice.textContent = price;
      const perUnit = root.querySelector('[data-per-unit]');
      if (perUnit) perUnit.textContent = wrap.dataset.variantPerUnit || '';
    }

    wraps.forEach((wrap) => {
      wrap.addEventListener('click', () => select(wrap));
      // Pfeiltasten wechseln das native Radio ohne Klick — Formularwerte nachziehen.
      const radio = wrap.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change', () => select(wrap));
      wrap.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select(wrap);
        }
      });
    });

    // Standardauswahl kommt aus dem Theme-Editor; ohne Markierung bleibt es die erste Karte.
    const initial = root.querySelector('[data-variant-wrap][data-variant-default]') || wraps[0];
    if (initial) select(initial);
  }

  async function addToCart(form) {
    const formData = new FormData(form);
    // Der Cart-Drawer hat einen schnellen Pfad: er geht sofort auf und spart
    // einen Abruf. Ohne Drawer (z. B. auf alten Layouts) bleibt es beim alten Weg.
    if (window.fnCartDrawer && window.fnCartDrawer.add) {
      await window.fnCartDrawer.add(formData);
      return;
    }
    try {
      // Mit festen Paketen im Warenkorb ersetzt die Auswahl das Paket, statt
      // Mengen aufzuaddieren (sonst entstehen 4, 6 … Packungen ohne Angebot).
      let res = null;
      const packMode = document.querySelector('[data-cart-drawer][data-pack-options]');
      if (packMode) {
        const current = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
        const id = String(formData.get('id') || '');
        const line = (current.items || []).find((it) => String(it.variant_id) === id);
        if (line) {
          res = await fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: parseInt(formData.get('quantity'), 10) || 1 }),
          });
        }
      }
      if (!res) res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) {
        // Surface Shopify's own (localized) reason, e.g. "… ist bereits ausverkauft".
        let reason = '';
        try {
          const data = await res.json();
          reason = data.description || data.message || '';
        } catch (parseErr) {}
        alert(reason || 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
        return;
      }
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartRes.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      // Open cart drawer if Horizon's cart drawer exists, else go to /cart
      const drawerTrigger = document.querySelector('[data-cart-drawer-trigger]');
      if (drawerTrigger) {
        drawerTrigger.click();
      } else {
        window.location.href = '/cart';
      }
    } catch (e) {
      console.error(e);
      alert('Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
    }
  }

  function initForm(form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(form);
    });
  }

  // ---- Hero-Galerie Tracking ------------------------------------------------
  // Misst, wie weit Besucher durch die Hero-Galerie navigieren — egal ob per
  // Klick (Desktop-Pfeile/Thumbs) oder Wisch (Mobile-Scroll-Track). Je erreichtem
  // Bild wird genau EIN Event pro Seitenaufruf an alle vorhandenen Analytics-
  // Backends gefeuert: Microsoft Clarity (Custom-Event + Tag), GA4/GTM (dataLayer)
  // und gtag. Kein Backend vorhanden = still, kein Fehler.
  let galleryMaxSlide = 1; // Bild 1 ist der Startzustand, zaehlt nicht als "weiter"

  function fnAnalytics(eventName, slide) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
        window.clarity('set', 'hero_max_slide', String(slide));
      }
    } catch (e) {}
    try {
      // dataLayer immer anlegen: GTM verarbeitet vor dem Laden gequeute Pushes,
      // und ohne GTM ist das Array harmlos.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, hero_slide: slide });
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, { hero_slide: slide });
      }
    } catch (e) {}
    try {
      // Shopify-Pixel-Pfad: Custom Pixels (auch sandboxed Apps) koennen dieses
      // Event via analytics.subscribe(eventName, ...) abonnieren.
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, { hero_slide: slide });
      }
    } catch (e) {}
  }

  // index ist 0-basiert; die menschlich sichtbare Bildnummer ist index + 1.
  function trackGallerySlide(index) {
    const slide = (index | 0) + 1;
    if (slide <= galleryMaxSlide) return; // nur das erste Erreichen zaehlt
    galleryMaxSlide = slide;
    // Sammel-Event beim ersten Sprung ueber Bild 1 hinaus: "hat ueberhaupt weiter".
    if (slide === 2) fnAnalytics('hero_gallery_advanced', slide);
    // Meilenstein je Bild ab Bild 2 — in Clarity/GA einzeln filterbar.
    fnAnalytics('hero_gallery_slide_' + slide, slide);
  }

  function initGallery(root) {
    const mainImg = root.querySelector('[data-gallery-main]');
    if (!mainImg) return;
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');
    // On the v2 hero the lead shot lives in the main frame and is NOT repeated
    // in the thumb row, so it has to be slide 0 of its own — otherwise the
    // arrows could never bring the merchant back to the first image.
    const isV2 = !!mainImg.closest('.fn2-phero__main');
    const lead = {
      src: mainImg.getAttribute('src'),
      mobileSrc: mainImg.dataset.galleryMobileSrc || '',
      srcset: mainImg.getAttribute('srcset') || '',
      sizes: mainImg.getAttribute('sizes') || '',
      alt: mainImg.getAttribute('alt') || '',
    };
    const slides = isV2
      ? [lead].concat(thumbs.map((t) => ({ src: t.dataset.src, mobileSrc: t.dataset.mobileSrc || '', alt: t.dataset.alt || '' })))
      : thumbs.map((t) => ({ src: t.dataset.src, mobileSrc: t.dataset.mobileSrc || '', alt: t.dataset.alt || '' }));
    let current = 0;

    function goTo(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      const slide = slides[current];
      if (slide.src) {
        // The lead <img> carries a srcset; leaving it in place would keep the
        // browser painting the original candidate no matter what src says.
        if (slide.srcset) {
          mainImg.setAttribute('srcset', slide.srcset);
          if (slide.sizes) mainImg.setAttribute('sizes', slide.sizes);
        } else {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
        }
        mainImg.src = window.matchMedia('(max-width: 899px)').matches && slide.mobileSrc ? slide.mobileSrc : slide.src;
        mainImg.alt = slide.alt;
      }
      const activeThumb = isV2 ? current - 1 : current;
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === activeThumb));
      trackGallerySlide(current);
    }

    const lightbox = initLightbox(root, slides);
    // On mobile the v2 gallery is a swipe track: every slide is already on
    // screen, so there is no lead frame left to re-fill.
    const isTrack = () => isV2 && window.matchMedia('(max-width: 899px)').matches;

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        const index = isV2 ? i + 1 : i;
        // Desktop still swaps the lead frame so closing the preview leaves the
        // clicked shot in place; either way the click opens the preview.
        if (!isTrack()) goTo(index);
        if (lightbox) {
          lightbox.open(index);
        }
      });
      if (lightbox) thumb.classList.add('is-zoomable');
    });

    if (lightbox) {
      mainImg.classList.add('is-zoomable');
      mainImg.addEventListener('click', () => lightbox.open(current));
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    // Mobile: swipe left/right on the main image to change slides. The v2
    // gallery is a native snap-scroll track on mobile, so it needs no handler
    // here — one would fight the scroller.
    if (!isV2) {
      const swipeArea = mainImg.closest('.fn-hero__gallery') || mainImg;
      let touchStartX = 0, touchStartY = 0, touching = false;
      swipeArea.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) { touching = false; return; }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touching = true;
      }, { passive: true });
      swipeArea.addEventListener('touchend', (e) => {
        if (!touching || slides.length <= 1) return;
        touching = false;
        const t = e.changedTouches[0];
        const dx = t.clientX - touchStartX;
        const dy = t.clientY - touchStartY;
        // Only act on a clear, mostly-horizontal swipe (don't hijack vertical scroll)
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          goTo(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });
    }

    if (slides.length <= 1) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    }

    initGalleryDots(root);
  }

  // Full-screen image preview. Returns null when the section has it switched
  // off, so the gallery keeps working exactly as before.
  function initLightbox(root, slides) {
    const box = root.querySelector('[data-gallery-lightbox]');
    if (!box || !slides.length) return null;

    // Reparent to <body>: inside the section any ancestor that creates a
    // stacking context or a containing block (container-type, transform) would
    // trap the overlay. A re-rendered section in the theme editor would leave
    // its old copy behind, so drop that one first.
    const owner = root.closest('.shopify-section');
    if (owner && owner.id) {
      const stale = document.querySelector('body > [data-gallery-lightbox][data-owner="' + owner.id + '"]');
      if (stale) stale.remove();
      box.setAttribute('data-owner', owner.id);
    }
    if (box.parentElement !== document.body) document.body.appendChild(box);

    const img = box.querySelector('[data-lightbox-img]');
    const prevBtn = box.querySelector('[data-lightbox-prev]');
    const nextBtn = box.querySelector('[data-lightbox-next]');
    let index = 0;
    let lastFocus = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      const slide = slides[index];
      // the lead carries a srcset that would otherwise win over the new src
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = window.matchMedia('(max-width: 899px)').matches && slide.mobileSrc ? slide.mobileSrc : slide.src;
      img.alt = slide.alt || '';
    }

    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      box.hidden = false;
      document.documentElement.classList.add('fn2-lightbox-open');
      // Flush the hidden -> visible change so the fade has a start value. A
      // requestAnimationFrame would be throttled on background/idle frames and
      // the box would stay at opacity 0, i.e. open but invisible.
      void box.offsetWidth;
      box.classList.add('is-open');
      const close = box.querySelector('[data-lightbox-close]:not(.fn2-lightbox__backdrop)');
      if (close) close.focus();
    }

    function close() {
      box.classList.remove('is-open');
      box.hidden = true;
      document.documentElement.classList.remove('fn2-lightbox-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    box.querySelectorAll('[data-lightbox-close]').forEach((el) => {
      el.addEventListener('click', close);
    });
    if (prevBtn) prevBtn.addEventListener('click', () => show(index - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(index + 1));

    document.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });

    // Swipe through the preview on touch devices.
    let startX = 0, startY = 0, touching = false;
    box.addEventListener('touchstart', (e) => {
      touching = e.touches.length === 1;
      if (!touching) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', (e) => {
      if (!touching || slides.length <= 1) return;
      touching = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });

    return { open, close };
  }

  // Mobile only: the gallery is a horizontal scroll track there, so the dots
  // follow the scroll position rather than the (desktop) thumb selection.
  function initGalleryDots(root) {
    const dots = root.querySelector('[data-gallery-dots]');
    if (!dots) return;
    const track = root.querySelector('.fn2-phero__gallery');
    if (!track) return;
    const items = Array.from(dots.children);
    if (items.length <= 1) { dots.style.display = 'none'; return; }

    let queued = false;
    track.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        // stride is slide width + gap, not the scrollport width
        const slides = track.querySelectorAll('.fn2-phero__main, .fn2-phero__thumb');
        const step = slides.length > 1
          ? slides[1].offsetLeft - slides[0].offsetLeft
          : track.clientWidth || 1;
        const i = Math.min(items.length - 1, Math.round(track.scrollLeft / (step || 1)));
        items.forEach((d, n) => d.classList.toggle('is-active', n === i));
        trackGallerySlide(i);
      });
    }, { passive: true });
  }

  /* v2 hero: the gallery column is much shorter than the buy box, so it scrolls
     with the page until its bottom reaches the bottom of the viewport and then
     locks there — same behaviour as the original product page. Desktop only;
     on mobile the gallery is a horizontal swipe track. */
  function initStickyGalleryV2(root) {
    const gallery = root.querySelector('.fn2-phero__gallery');
    if (!gallery) return;

    const GAP = 16; // breathing room under the locked gallery

    function update() {
      if (window.innerWidth < 900) {
        gallery.style.removeProperty('--fn2-gallery-sticky-top');
        return;
      }
      // Where the gallery starts inside the hero. Measured with sticky switched
      // off for one frame, so a mid-page resize can't read a shifted box.
      gallery.style.position = 'static';
      const flowTop = Math.round(gallery.getBoundingClientRect().top - root.getBoundingClientRect().top);
      const height = gallery.scrollHeight;
      gallery.style.position = '';

      // Header offset the section itself already sits below.
      const headerH = Math.round(root.getBoundingClientRect().top + window.scrollY);
      const lock = Math.min(headerH + flowTop, window.innerHeight - height - GAP);
      gallery.style.setProperty('--fn2-gallery-sticky-top', lock + 'px');
    }

    update();
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('load', update, { passive: true });
  }

  function initStickyMediaCenter(root) {
    const media = root.querySelector('.fn-hero__media');
    if (!media) return;

    const VISUAL_GAP = 24; // px gap between nav bottom and content (matches Figma)

    // Cache the natural header offset (sticky elements above hero)
    let cachedOffset = null;

    function getHeaderOffset() {
      if (cachedOffset !== null) return cachedOffset;
      cachedOffset = Math.round(root.getBoundingClientRect().top + window.scrollY);
      return cachedOffset;
    }

    function update() {
      cachedOffset = null;
      const headerH = getHeaderOffset();
      const vh = window.innerHeight;
      const mediaH = media.scrollHeight;

      // The media's natural top while still in flow (header + visual gap).
      const mediaStartY = headerH + VISUAL_GAP;

      // Lock only once the BOTTOM of the media (image + thumbnails) reaches the
      // bottom of the viewport — i.e. the thumbnails have scrolled into view
      // (top = vh - mediaH). Cap at the natural start so sticking engages on
      // scroll-down rather than firing immediately. When the media is taller than
      // the viewport this value is negative, so the media scrolls the full
      // distance needed to reveal the thumbnails before locking (the top tucks
      // under the nav, which is unavoidable when the media can't fully fit).
      const stickyTop = Math.min(mediaStartY, vh - mediaH);

      root.style.paddingTop = VISUAL_GAP + 'px';
      media.style.marginTop = '';
      media.style.setProperty('--media-sticky-top', stickyTop + 'px');
    }

    update();
    window.addEventListener('resize', update, { passive: true });
  }

  // Order and isolation both matter here. Add-to-cart and the package
  // pre-selection are the only two things the page cannot do without, so they
  // run first — before the gallery and sticky-layout helpers, which touch far
  // more optional markup and are the ones likely to hit a missing element on a
  // template variant. Each step is caught on its own as well: an exception used
  // to abort the whole callback, which would leave the buy button with no
  // submit handler and no selected package — a silently dead button.
  function guard(label, fn) {
    try {
      fn();
    } catch (e) {
      console.error('[functions-product] ' + label + ' failed', e);
    }
  }

  document.querySelectorAll('[data-functions-product]').forEach((root) => {
    const form = root.querySelector('form[data-add-to-cart-form]');
    if (form) guard('form', () => initForm(form));
    guard('variant picker', () => initVariantPicker(root));
    guard('gallery', () => initGallery(root));
    guard('sticky gallery', () => initStickyGalleryV2(root));
    guard('sticky media', () => initStickyMediaCenter(root));
  });
})();
